const tmStyle = {
fontSize: '0.5em',
verticalAlign: 'super'
};

const products = [
  {
    id: 'datecalendar',
    name: 'Date Calendar',
    shortDesc: 'Full-year calendar in one view',
    heroImage: '/Graphics/Product Screenshots/DateCalendar_01.png',
    screenshots: [
      '/Graphics/Product Screenshots/DateCalendar_01.png',
      '/Graphics/Product Screenshots/DateCalendar_02.png',
      '/Graphics/Product Screenshots/DateCalendar_03.png',
      '/Graphics/Product Screenshots/DateCalendar_04.png',
      '/Graphics/Product Screenshots/DateCalendar_05.png',
      '/Graphics/Product Screenshots/DateCalendar_06.png',
      '/Graphics/Product Screenshots/DateCalendar_07.png',
      '/Graphics/Product Screenshots/DateCalendar_08.png',
      '/Graphics/Product Screenshots/DateCalendar_09.png',
    ],
    download: '/downloads/NeuLogicDateCalendar.zip',
    description: `<div style='text-align:left;'>
<b>NeuLogic<span style={tmStyle}>™</span> Date Calendar</b> provides a clean, efficient interface for viewing an entire year at once. Ideal for those who need a straightforward date reference tool without the complexity of scheduling software.<br/><br/>
<b>Key Features:</b><ul>
<li>Complete Year View — See all months simultaneously for efficient planning</li>
<li>Holiday Management — Track standard holidays and add custom dates</li>
<li>Advanced Date Calculations — Add/subtract days, find days between dates, generate date series</li>
<li>Visual Highlighting — Easily identify weekends, holidays, and today's date</li>
<li>Simple Year Navigation — Quick access to past and future years</li>
<li>Offline Security — Works without internet connection for complete privacy</li>
<li>Clean Interface — Distraction-free design focused on functionality</li>
<li>Automatic Settings Retention — Preferences stored locally for convenience</li>
</ul>
<b>Ideal For:</b><ul>
<li>Professionals needing quick date reference and planning tools</li>
<li>Anyone tracking holidays and important dates</li>
<li>Users who prefer simplicity and efficiency over complex interfaces</li>
<li>Those concerned with privacy and offline functionality</li>
</ul>
NeuLogic<span style={tmStyle}>™</span> Date Calendar is designed as a reference and calculation tool, not a scheduling system—providing exactly what you need without unnecessary complications.<br/><br/>
<b>System Requirements:</b><ul>
<li>Windows 10 or higher</li>
<li>70 MB of free disk space</li>
<li>512 MB RAM</li>
</ul>
</div>`,
    price: 39.95,
    stripeLink: "https://buy.stripe.com/8wMbK64i83x9gne3cc"
  },
  {
    id: 'clipboardmgr',
    name: 'ScratchMan™',
    shortDesc: 'Save and reuse frequently pasted text lines',
    heroImage: '/Graphics/Product Screenshots/ScratchMan_03.png',
    screenshots: [
      '/Graphics/Product Screenshots/ScratchMan_01.png',
	  '/Graphics/Product Screenshots/ScratchMan_02.png',
	  '/Graphics/Product Screenshots/ScratchMan_03.png',
	  '/Graphics/Product Screenshots/ScratchMan_04.png',
	  '/Graphics/Product Screenshots/ScratchMan_05.png',
	  '/Graphics/Product Screenshots/ScratchMan_06.png',
	  '/Graphics/Product Screenshots/ScratchMan_07.png',
	  '/Graphics/Product Screenshots/ScratchMan_08.png',
    ],
    download: '/downloads/NeuLogicScratchMan.zip',
    description: `<div style='text-align:left;'>
<b>NeuLogic<span style={tmStyle}>™</span> ScratchMan<span style={tmStyle}>™</b> is an intelligent clipboard utility that gives you full control over your clipboard history. Designed for power users, developers, and productivity-focused professionals, ScratchMan<span style={tmStyle}>™ supports smart tabbed organization, custom clipboard entries, and built-in command processing—all while staying lightweight and unobtrusive.<br/><br/>
Forget the chaos of losing copied content or pasting the wrong thing—ScratchMan<span style={tmStyle}>™ remembers what you copied, when, and where, and even supports privacy protection and command macros like $DATE and $NOW.<br/><br/>
With both temporary (Scratch) and persistent (Custom) tabs, ScratchMan<span style={tmStyle}>™ adapts to your workflow. Use the Scratch tab for throwaway items, or save important content in named tabs with titles and protection. Add, edit, copy, paste, reorder, or hide content—all from an elegant interface.<br/><br/>
<b>Key Features:</b><ul>
<li>Tabbed clipboard history: Scratch (temporary) and Custom (persistent)</li>
<li>Built-in command processing: $DATE, $TIME, $NOW, and more</li>
<li>Privacy protection: Hide sensitive content behind dots (• • •)</li>
<li>Drag & drop reordering of pinned items</li>
<li>Paste directly with buttons or keyboard shortcuts</li>
<li>Real-time clipboard monitoring</li>
<li>System tray operation and always-on-top mode</li>
<li>License-based unlock for full functionality</li>
<li>Auto-save custom tabs to .cbt files</li>
</ul>
<b>Perfect For:</b><ul>
<li>Developers and IT professionals managing code snippets and commands</li>
<li>Writers and researchers curating copied notes and quotes</li>
<li>Anyone needing organized clipboard memory with smart controls</li>
<li>Teams managing templates, responses, or repeatable text</li>
</ul>
<b>App Features:</b><ul>
<li>Real-time clipboard monitoring</li>
<li>Commands: $DATE, $TIME, $NOW, $HELP</li>
<li>Evaluation mode with limited pinning (1 item)</li>
<li>Full license enables unlimited items and tabs</li>
<li>Built-in Help and About dialogs</li>
<li>Tab renaming, title editing, context menus</li>
<li>Visual content hints for whitespace/empty items</li>
<li>One-click paste buttons</li>
<li>Tray icon minimization</li>
<li>Persistent settings and tab contents</li>
</ul>
<b>System Requirements:</b><ul>
<li>Windows 10 or higher</li>
<li>50 MB of free disk space</li>
<li>512 MB RAM</li>
</ul>
</div>`,
    price: 24.95,
    stripeLink: "https://buy.stripe.com/bJe28taUV9DK5DEf8Nebu09"
  },
  {
    id: "contacts",
    name: "Contacts",
    shortDesc: 'Private, distraction-free contact manager',
    heroImage: '/Graphics/Product Screenshots/Contacts_001.png',
    screenshots: [
      '/Graphics/Product Screenshots/Contacts_001.png',
      '/Graphics/Product Screenshots/Contacts_002.png',
      '/Graphics/Product Screenshots/Contacts_003.png',
      '/Graphics/Product Screenshots/Contacts_004.png',
      '/Graphics/Product Screenshots/Contacts_005.png',
    ],
    download: '/downloads/NeuLogicContacts.zip',
    description: `<div style='text-align:left;'>
<b>NeuLogic<span style={tmStyle}>™</span> Contacts</b> is a modern, distraction-free contact manager built for users who want their address book to simply work—without pop-ups, AI prompts, upgrade banners, or feature announcements getting in the way.<br/><br/>

Designed from scratch with simplicity and privacy in mind, NeuLogic<span style={tmStyle}>™</span> Contacts provides a clean, contemporary interface for organizing personal and professional contacts. No bloat. No subscriptions. No cloud accounts required. Just a straightforward tool that respects both the user's time and their data.<br/><br/>

Traditional contact managers bundled with email and productivity suites have become cluttered with promotional overlays, AI integrations nobody asked for, and interfaces that haven't evolved in over a decade. NeuLogic<span style={tmStyle}>™</span> Contacts takes a different path: focused functionality, modern design, and complete user control.<br/><br/>

<b>What Sets It Apart:</b><ul>
<li><b>Zero distractions</b> — No ads, no AI prompts, no upgrade banners, no "Try this new feature!" pop-ups. Ever.</li>
<li><b>True privacy</b> — All data stays on the local machine. No mandatory cloud sync, no telemetry, no tracking.</li>
<li><b>Modern, clean interface</b> — Contemporary design with smooth visuals, intuitive navigation, and thoughtful spacing—not a relic from 2010.</li>
<li><b>Flexible organization</b> — Create custom categories to separate work, personal, family, clients, or any grouping that fits.</li>
<li><b>Optional cloud sync</b> — Store files on user-chosen cloud storage (OneDrive, Dropbox, Google Drive) for multi-device access without vendor lock-in.</li>
<li><b>Smart conflict handling</b> — Intelligent file sync detects and resolves conflicts when accessing contacts from multiple devices.</li>
<li><b>Import & export freedom</b> — CSV import/export makes migration easy and prevents data lock-in.</li>
<li><b>Fast and lightweight</b> — Launches instantly, uses minimal resources, and never slows down the system.</li>
<li><b>No account required</b> — No sign-ups, no email verification, no password resets. Install and use immediately.</li>
<li><b>No subscriptions</b> — One-time purchase with no recurring fees or artificially limited features.</li>
</ul>

<b>Perfect For:</b><ul>
<li>Users tired of pop-ups and promotional clutter in their productivity tools</li>
<li>Privacy-conscious individuals who prefer local data storage</li>
<li>Professionals who need organized contacts without enterprise complexity</li>
<li>Anyone frustrated with outdated, bloated address book interfaces</li>
<li>Users who want a standalone contact manager independent of email platforms</li>
<li>People who value software that does one thing exceptionally well</li>
</ul>

<b>The Bottom Line:</b> NeuLogic<span style={tmStyle}>™</span> Contacts delivers what an address book should be: fast, organized, private, and completely free of distractions. No forced integrations, no AI gimmicks, no subscription traps—just a beautifully designed tool that stays out of the way and lets users manage contacts the way they want.<br/><br/>

<b>App Features:</b><ul>
<li>Clean, modern interface with contemporary design</li>
<li>Custom categories for flexible organization</li>
<li>Fully offline operation</li>
<li>Optional sync via user-controlled cloud storage</li>
<li>Smart file conflict detection and resolution</li>
<li>CSV import and export</li>
<li>Fast search and filtering</li>
<li>Lightweight and resource-efficient</li>
<li>No ads, pop-ups, or promotional content</li>
<li>No account or sign-up required</li>
<li>No telemetry or data collection</li>
<li>Multi-monitor support</li>
</ul>

<b>System Requirements:</b><ul>
<li>Windows 10 or higher</li>
<li>50 MB of free disk space</li>
<li>256 MB RAM</li>
</ul>
</div>`,
    price: 29.95,
    stripeLink: "https://buy.stripe.com/dRmdRbaUV03ad663q5ebu0e"
  },
  {
    id: "datereminder",
    name: "Date Reminder",
    shortDesc: 'Just focused reminders without full calendar apps',
    heroImage: '/Graphics/Product Screenshots/DateReminder_001.png',
    screenshots: [
      '/Graphics/Product Screenshots/DateReminder_001.png',
      '/Graphics/Product Screenshots/DateReminder_002.png',
      '/Graphics/Product Screenshots/DateReminder_003.png',
      '/Graphics/Product Screenshots/DateReminder_004.png',
      '/Graphics/Product Screenshots/DateReminder_005.png',
      '/Graphics/Product Screenshots/DateReminder_006.png',
      '/Graphics/Product Screenshots/DateReminder_007.png',
      '/Graphics/Product Screenshots/DateReminder_008.png',
    ],
    download: '/downloads/NeuLogicDateReminder.zip',
    description: `<div style='text-align:left;'>
<b>NeuLogic<span style={tmStyle}>™</span> Date Reminder</b> is a simple, elegant system tray application that delivers reminders exactly when needed—without the bloat, complexity, or subscription fees of full calendar applications.<br/><br/>

Designed for users who need reliable reminders without managing an entire calendar ecosystem, NeuLogic<span style={tmStyle}>™</span> Date Reminder runs quietly in the background and surfaces only when it's time to act. No constant notifications, no intrusive interfaces, no cloud accounts required.<br/><br/>

Traditional calendar applications force users to navigate cluttered interfaces and wade through features they never use—just to set a simple reminder. NeuLogic<span style={tmStyle}>™</span> Date Reminder focuses on doing one thing exceptionally well: reminding users of important dates and tasks at the right moment.<br/><br/>

<b>What Sets It Apart:</b><ul>
<li><b>True lightweight design</b> — Runs silently in the system tray, consuming minimal resources and staying completely out of the way until needed.</li>
<li><b>No calendar overhead</b> — Skip the bloated calendar apps. Set reminders directly without navigating complex interfaces or syncing accounts.</li>
<li><b>Flexible recurrence</b> — One-time, daily, weekly, monthly, or yearly reminders with intuitive scheduling options.</li>
<li><b>Smart popup notifications</b> — Clean, unobtrusive popups that display exactly when reminders are due, with snooze and dismiss options.</li>
<li><b>Category organization</b> — Organize reminders by type: bills, appointments, birthdays, tasks, notes, and custom categories.</li>
<li><b>Reminder history</b> — All dismissed and deleted reminders are logged for future reference.</li>
<li><b>Starts with Windows</b> — Automatically launches at startup so reminders are never missed.</li>
<li><b>Fully offline</b> — No cloud accounts, no internet dependency, no syncing complications.</li>
<li><b>Modern interface</b> — Clean, contemporary design with intuitive controls and calendar integration.</li>
<li><b>No subscriptions</b> — One-time purchase with no recurring fees.</li>
</ul>

<b>Perfect For:</b><ul>
<li>Users who need reminders without managing a full calendar application</li>
<li>Anyone tired of bloated productivity suites for simple reminder needs</li>
<li>Professionals tracking recurring tasks, bills, and deadlines</li>
<li>Users who want reminders that run locally without cloud dependencies</li>
<li>People who value lightweight tools that stay out of the way</li>
<li>Anyone who has missed important dates because calendar apps are too cumbersome to use</li>
</ul>

<b>The Bottom Line:</b> NeuLogic<span style={tmStyle}>™</span> Date Reminder delivers exactly what users need—reliable, timely reminders—without the overhead of full calendar applications. It runs quietly, notifies intelligently, and never gets in the way.<br/><br/>

<b>App Features:</b><ul>
<li>System tray application with minimal footprint</li>
<li>One-time, daily, weekly, monthly, and yearly reminders</li>
<li>Smart popup notifications with snooze options</li>
<li>Category-based organization</li>
<li>Reminder history logging</li>
<li>Quick date selection with calendar dropdown</li>
<li>Day offset selector for relative date scheduling</li>
<li>Automatic Windows startup</li>
<li>Fully offline operation</li>
<li>Modern, clean interface</li>
<li>No account required</li>
<li>No telemetry or data collection</li>
</ul>

<b>System Requirements:</b><ul>
<li>Windows 10 or higher</li>
<li>50 MB of free disk space</li>
<li>256 MB RAM</li>
</ul>
</div>`,
    price: 29.95,
    stripeLink: "https://buy.stripe.com/6oU00l6EF5nu8PQgcRebu0f"
  },
  {
    id: 'desktopclock',
    name: 'Desktop Clock',
    shortDesc: 'Customizable clock placed where you need it',
    heroImage: '/Graphics/Product Screenshots/DesktopClock_0001.png',
    screenshots: [
      '/Graphics/Product Screenshots/DesktopClock_0001.png',
      '/Graphics/Product Screenshots/DesktopClock_0002.png',
      '/Graphics/Product Screenshots/DesktopClock_0003.png',
      '/Graphics/Product Screenshots/DesktopClock_0004.png',
      '/Graphics/Product Screenshots/DesktopClock_0005.png',
      '/Graphics/Product Screenshots/DesktopClock_0006.png',
      '/Graphics/Product Screenshots/DesktopClock_0007.png',
      '/Graphics/Product Screenshots/DesktopClock_0008.png',
      '/Graphics/Product Screenshots/DesktopClock_0009.png',
      '/Graphics/Product Screenshots/DesktopClock_0010.png',
      '/Graphics/Product Screenshots/DesktopClock_0011.png',
      '/Graphics/Product Screenshots/DesktopClock_0012.png',
      '/Graphics/Product Screenshots/DesktopClock_0013.png',
      '/Graphics/Product Screenshots/DesktopClock_0014.png',
      '/Graphics/Product Screenshots/DesktopClock_0015.png',
    ],
    download: '/downloads/NeuLogicDesktopClock.zip',
    description: `<div style='text-align:left;'>
<b>NeuLogic<span style={tmStyle}>™</span> Desktop Clock</b> is a polished, always-available desktop clock for Windows that combines elegant design with practical everyday functionality. It offers both a refined analog face and a modern digital display, while staying lightweight, unobtrusive, and easy to control from a compact right-click menu.<br/><br/>

Built for real desktop use, Desktop Clock goes far beyond a simple time display. It can stay visible above other windows, snap into convenient screen positions, temporarily hide when screen space is needed, and even show additional hover-based clocks for other time zones. Whether the goal is a classic clock face, a clean digital display, or quick access to multiple world times, the app is designed to keep that information available without clutter.<br/><br/>

The application offers two distinct display modes:<ul>
<li>Elegant analog clock with date and weekday display</li>
<li>Modern digital clock with 12/24-hour support and glow styling</li>
<li>Quick switching between analog and digital modes from the menu</li>
</ul>

<b>Key Features:</b><ul>
<li>Dual Display Modes — Switch between analog and digital clock faces at any time</li>
<li>Smooth Analog Movement — Optional smooth hand movement for a more natural analog look</li>
<li>Digital Display Options — 12/24-hour format support, multiple color choices, and soft glow effects</li>
<li>Date and Weekday Display — The analog clock includes a built-in date and weekday readout</li>
<li>Custom Clocks — Add hover-based extra clocks for other time zones with searchable city and region lookup</li>
<li>Timezone Support — Track multiple locations with DST-aware timezone handling</li>
<li>Fully Draggable — Move the clock freely anywhere on the screen</li>
<li>Snap Positioning — Double-click to snap to preset positions, including side and corner placement options</li>
<li>Adjustable Size — Resize the clock to fit different desktop layouts and preferences</li>
<li>Always on Top — Keep the clock visible above other windows</li>
<li>Temporary Hide — Hide the clock for a selected duration and have it return automatically</li>
<li>Panic Mode — Instantly minimize the active window with a single click on the clock</li>
<li>System Tray Integration — Access controls from the tray and recover the clock if needed</li>
<li>Show Clock Recovery Option — Bring the clock back quickly if it goes off-screen or gets hidden</li>
<li>Auto-Start with Windows — Launch automatically when Windows starts</li>
<li>Multi-Monitor Support — Works across multiple displays and uses the active screen for positioning</li>
<li>Frameless Transparent Design — Clean desktop appearance without a standard window frame</li>
<li>Built-In Update Check — Check for newer versions and download updates directly from the app</li>
<li>Offline Core Use — Normal clock functionality works without requiring an internet connection</li>
<li>Low Resource Usage — Designed to stay useful without becoming intrusive</li>
</ul>

<b>Perfect For:</b><ul>
<li>Professionals who want visible time without opening extra apps or panels</li>
<li>Users who like having a clean analog or digital clock on the desktop</li>
<li>Anyone who works across multiple time zones</li>
<li>People who want quick-hide and fast recovery options while working</li>
<li>Users who enjoy practical desktop customization with a polished look</li>
</ul>

Keep time visible, elegant, and easy to control with NeuLogic<span style={tmStyle}>™</span> Desktop Clock.<br/><br/>

<b>App Features:</b><ul>
<li>Analog and digital display modes</li>
<li>Optional smooth analog hand movement</li>
<li>Digital color, glow, and 12/24-hour options</li>
<li>Date and weekday display on analog face</li>
<li>Custom hover-based timezone clocks</li>
<li>Searchable timezone selection</li>
<li>Drag positioning and snap-to-position support</li>
<li>Adjustable size options</li>
<li>Always-on-top functionality</li>
<li>Temporary hide with automatic return</li>
<li>Panic mode for quick active-window minimization</li>
<li>System tray access and clock recovery option</li>
<li>Auto-start with Windows</li>
<li>Multi-monitor support</li>
<li>Built-in update checking and download</li>
<li>Transparent frameless desktop presentation</li>
</ul>
<b>System Requirements:</b><ul>
<li>Windows 10 or higher</li>
<li>50 MB of free disk space</li>
<li>Minimal memory usage</li>
</ul>
</div>`,
    price: 19.95,
    stripeLink: "https://buy.stripe.com/4gwaG27ukd7Jef67st"
  },
  {
    id: 'filemonitor',
    name: 'File Monitor',
    shortDesc: 'Automatic backup on every file change',
    heroImage: '/Graphics/Product Screenshots/FileMonitor_01.png',
    screenshots: [
      '/Graphics/Product Screenshots/FileMonitor_01.png',
      '/Graphics/Product Screenshots/FileMonitor_02.png',
      '/Graphics/Product Screenshots/FileMonitor_03.png',
      '/Graphics/Product Screenshots/FileMonitor_04.png',
      '/Graphics/Product Screenshots/FileMonitor_05.png',
      '/Graphics/Product Screenshots/FileMonitor_06.png',
      '/Graphics/Product Screenshots/FileMonitor_07.png',
      '/Graphics/Product Screenshots/FileMonitor_08.png',
      '/Graphics/Product Screenshots/FileMonitor_09.png',
	  '/Graphics/Product Screenshots/FileMonitor_10.png',
    ],
    download: '/downloads/NeuLogicFileMonitor.zip',
    description: `<div style='text-align:left;'>
<b>NeuLogic<span style={tmStyle}>™</span> File Monitor</b> automatically saves every change made to selected files, allowing you to roll back to previous versions or compare changes over time. Designed for developers, testers, and professionals working with evolving files, this tool ensures you never lose track of what changed or when.<br/><br/>
<b>Key Features:</b><ul>
<li>Real-Time Monitoring — Detects and saves each change automatically</li>
<li>Versioned Backups — Every saved version is uniquely numbered and timestamped</li>
<li>Rollback Support — Revert to any earlier version with ease</li>
<li>Change Comparison — Use external tools to compare saved versions for debugging</li>
<li>External Change Detection — Captures file updates made by other applications</li>
<li>Multiple Monitoring Panels — Track several files independently</li>
<li>Commentable Logs — Add notes to log entries for context</li>
<li>Drag-and-Drop Simplicity — Quickly add files to monitor</li>
<li>Custom Temp Folder Locations — Choose where your backup files go</li>
<li>Offline Operation — No internet connection required; full privacy guaranteed</li>
</ul>
<b>Ideal For:</b><ul>
<li>Developers and testers monitoring live config/code changes</li>
<li>Users wanting version history for critical documents or scripts</li>
<li>Anyone needing to track and compare file changes, including automated edits</li>
</ul>
NeuLogic<span style={tmStyle}>™</span> File Monitor is a safety net for your work — capturing changes in real time and enabling confident experimentation and easy recovery.<br/><br/>
<b>System Requirements:</b><ul>
<li>Windows 10 or higher</li>
<li>50 MB of free disk space</li>
<li>128 MB RAM</li>
</ul>
</div>`,
    price: 24.95,
    stripeLink: "https://buy.stripe.com/00wfZj2opcPW8PQ9Otebu08"
  },
  {
    id: 'marknote',
    name: 'MarkNote™',
    shortDesc: 'Markdown editor with live preview',
    heroImage: '/Graphics/Product Screenshots/MarkNote_02.png',
    screenshots: [
      '/Graphics/Product Screenshots/MarkNote_01.png',
      '/Graphics/Product Screenshots/MarkNote_02.png',
      '/Graphics/Product Screenshots/MarkNote_03.png',
      '/Graphics/Product Screenshots/MarkNote_04.png',
      '/Graphics/Product Screenshots/MarkNote_05.png',
      '/Graphics/Product Screenshots/MarkNote_06.png',
      '/Graphics/Product Screenshots/MarkNote_07.png',
      '/Graphics/Product Screenshots/MarkNote_08.png',
      '/Graphics/Product Screenshots/MarkNote_09.png',
	  '/Graphics/Product Screenshots/MarkNote_10.png',
    ],
    download: '/downloads/NeuLogicMarkNote.zip',
    description: `<div style='text-align:left;'>
<b>NeuLogic<span style={tmStyle}>™</span> MarkNote<span style={tmStyle}>™</span></b> is a powerful document editor with custom markup syntax designed for productivity and multi-project organization. Whether you're writing documentation, taking notes, or creating content, MarkNote<span style={tmStyle}>™</span> provides real-time WYSIWYG preview, multi-workspace organization, and professional formatting tools.<br/><br/>
The app combines plain text editing with instant visual preview, offering source and preview modes in a tabbed interface with detachable preview windows for multi-monitor setups. With built-in spell checking, multi-workspace support, and advanced text manipulation features, MarkNote<span style={tmStyle}>™</span> streamlines your writing workflow across multiple projects.<br/><br/>
<b>Key Features:</b><ul>
<li>Multi-Workspace Spaces - Organize tabs into separate workspaces for different projects</li>
<li>Real-Time WYSIWYG Preview - See formatted output instantly as you type with synchronized scrolling</li>
<li>Pop-out Preview Window - Detach preview to separate window for multi-monitor workflows</li>
<li>Custom Markup Syntax - Powerful formatting with bracket-based tags, custom colors, and callout boxes</li>
<li>Real-Time Spell Checking - Built-in spell checker with visual indicators and right-click suggestions</li>
<li>External File Monitoring - Automatic detection when files are modified by other programs</li>
<li>Advanced Tab Management - Pin tabs, visual status indicators, rich tooltips with file information</li>
<li>Auto-Save Functionality - 10-minute auto-save with visual feedback for document protection</li>
<li>Find & Replace - Cross-document search with reliable fast-click handling and match highlighting</li>
<li>Line Change Indicators - Visual orange bars showing modifications since last save</li>
<li>Universal File Embedding - Embed images, HTML, code files, and documents directly in your content</li>
<li>Smart Text Operations - Line movement, context-aware indentation, and word highlighting on selection</li>
<li>Crash Recovery - Automatic backup and recovery of unsaved changes from previous sessions</li>
<li>Enhanced Copy Features - Click code blocks and URLs to copy content to clipboard instantly</li>
<li>Comprehensive Keyboard Shortcuts - Full shortcut support including Alt+Letter menu navigation</li>
</ul>
<b>Ideal For:</b><ul>
<li>Software developers managing multiple documentation projects with code embedding</li>
<li>Technical writers working across different client projects with custom formatting needs</li>
<li>Students organizing notes by subject using separate workspaces</li>
<li>Content creators who need reliable spell checking and advanced formatting options</li>
<li>Multi-monitor users maximizing screen real estate with detached preview windows</li>
<li>Project managers documenting processes with embedded files and visual callouts</li>
<li>Anyone requiring professional multi-project document workflow with crash protection</li>
</ul>
<b>System Requirements:</b><ul>
<li>Windows 10 or higher</li>
<li>75 MB of free disk space</li>
<li>512 MB RAM</li>
</ul>
</div>`,
    price: 39.95,
    stripeLink: "https://buy.stripe.com/dRmcN7bYZ8zGaXY7Glebu0c"
  },
  {
    id: "neuwallet",
    name: "NeuWallet™",
    shortDesc: 'Offline encrypted password manager',
    heroImage: '/Graphics/Product Screenshots/NeuWallet_005.png',
    screenshots: [
      '/Graphics/Product Screenshots/NeuWallet_001.png',
      '/Graphics/Product Screenshots/NeuWallet_002.png',
      '/Graphics/Product Screenshots/NeuWallet_003.png',
      '/Graphics/Product Screenshots/NeuWallet_004.png',
      '/Graphics/Product Screenshots/NeuWallet_005.png',
      '/Graphics/Product Screenshots/NeuWallet_006.png',
      '/Graphics/Product Screenshots/NeuWallet_007.png',
      '/Graphics/Product Screenshots/NeuWallet_008.png',
      '/Graphics/Product Screenshots/NeuWallet_009.png',
      '/Graphics/Product Screenshots/NeuWallet_010.png',
      '/Graphics/Product Screenshots/NeuWallet_011.png',
      '/Graphics/Product Screenshots/NeuWallet_012.png',
      '/Graphics/Product Screenshots/NeuWallet_013.png',
      '/Graphics/Product Screenshots/NeuWallet_014.png',
      '/Graphics/Product Screenshots/NeuWallet_015.png',
      '/Graphics/Product Screenshots/NeuWallet_016.png',
      '/Graphics/Product Screenshots/NeuWallet_017.png',
    ],
    download: '/downloads/NeuWallet.zip',
    description: `<div style='text-align:left;'>
<b>NeuWallet<span style={tmStyle}>™</span></b> is a modern, powerful desktop application that puts users back in control of their most sensitive data. Built from the ground up with privacy, security, and usability at its core, it delivers what the market has been missing: a truly private password manager that doesn’t compromise on features, design, or clarity.<br/><br/>

NeuWallet<span style={tmStyle}>™</span> securely stores and manages passwords, credit cards, bank accounts, secure notes, documents, and more. All data remains encrypted on the local computer, protected with industry-standard security and presented through a clean, contemporary interface designed for everyday use.<br/><br/>

Many password managers require storing sensitive data on third-party servers, introducing privacy risks, subscriptions, and constant internet dependency. Others are legacy desktop tools that haven’t meaningfully evolved in years—still offering clunky interfaces and blurry, low-resolution images. NeuWallet<span style={tmStyle}>™</span> takes a different approach: fully offline, visually modern, and entirely under the user’s control.<br/><br/>

<b>What Sets It Apart:</b><ul>
<li><b>True privacy</b> — No cloud sync required. Data never leaves the computer unless explicitly stored on user-chosen cloud storage for multi-device access. No telemetry. No tracking.</li>
<li><b>Military-grade security</b> — AES-256 encryption with secure key derivation protects every vault and every field.</li>
<li><b>Crystal-clear image support</b> — Store credit cards, IDs, and documents with high-resolution images. Display front and back sides, use images as card backgrounds, or create dedicated image cards.</li>
<li><b>Modern, intuitive interface</b> — Clean layout, smooth rendering, rounded corners, and thoughtful spacing built with contemporary design principles.</li>
<li><b>Flexible organization</b> — Multiple encrypted vaults allow separation of personal, work, family, or any other data sets.</li>
<li><b>Smart password generation</b> — Generate strong passwords with customizable rules and insert them directly into focused fields.</li>
<li><b>Instant access & control</b> — Single-click copying of any field with automatic clipboard clearing for added security.</li>
<li><b>Powerful customization</b> — Built-in templates for common data types, unlimited custom fields, customizable card visuals, and icons for instant recognition.</li>
<li><b>Advanced protection features</b> — Auto-lock on inactivity, masked sensitive fields with right-click reveal, and secure handling of PINs, CVVs, and security answers.</li>
<li><b>No subscriptions</b> — One-time purchase with no recurring fees or locked features.</li>
<li><b>Import & export freedom</b> — Easily back up data or migrate from other applications without vendor lock-in.</li>
</ul>

<b>Perfect For:</b><ul>
<li>Privacy-conscious users who refuse to store passwords on vendor servers</li>
<li>Professionals managing sensitive personal or client information</li>
<li>Users frustrated with outdated password managers and blurry image support</li>
<li>Anyone who wants full control over where and how sensitive data is stored</li>
<li>People who need high-quality image storage for cards, IDs, and documents</li>
<li>Users who value strong security paired with a genuinely pleasant user experience</li>
</ul>

<b>The Bottom Line:</b> NeuWallet<span style={tmStyle}>™</span> combines modern design, crystal-clear visuals, powerful organization, and true offline privacy—without subscriptions, cloud dependency, or outdated interfaces. It’s a password manager built for how people actually work today.<br/><br/>

<b>App Features:</b><ul>
<li>AES-256 military-grade encryption</li>
<li>Fully offline operation with optional user-controlled cloud storage</li>
<li>High-resolution image support with front and back display</li>
<li>Image backgrounds and dedicated image cards</li>
<li>Multiple encrypted vaults</li>
<li>Comprehensive template system with unlimited custom fields</li>
<li>Smart password generator with direct field insertion</li>
<li>Single-click copying with automatic clipboard clearing</li>
<li>Advanced search and filtering</li>
<li>Recent files quick access</li>
<li>Import/export functionality</li>
<li>Auto-lock on inactivity</li>
<li>No telemetry or data collection</li>
<li>Modern, intuitive interface</li>
</ul>

<b>System Requirements:</b><ul>
<li>Windows 10 or higher</li>
<li>50 MB of free disk space</li>
<li>256 MB RAM</li>
</ul>
</div>`,
    price: 39.95,
    stripeLink: "https://buy.stripe.com/28E8wRfbb17ed66gcRebu0d"
  },
  {
    id: 'passkeygenerator',
    name: 'Passkey Generator',
    shortDesc: 'Generate passwords, PINs, and UUIDs',
    heroImage: '/Graphics/Product Screenshots/PasskeyGenerator_001.png',
    screenshots: [
      '/Graphics/Product Screenshots/PasskeyGenerator_001.png',
      '/Graphics/Product Screenshots/PasskeyGenerator_002.png',
      '/Graphics/Product Screenshots/PasskeyGenerator_003.png',
      '/Graphics/Product Screenshots/PasskeyGenerator_004.png',
      '/Graphics/Product Screenshots/PasskeyGenerator_005.png',
      '/Graphics/Product Screenshots/PasskeyGenerator_006.png',
      '/Graphics/Product Screenshots/PasskeyGenerator_007.png',
      '/Graphics/Product Screenshots/PasskeyGenerator_008.png',
    ],
    download: '/downloads/NeuLogicPasskeyGenerator.zip',
    description: `<div style='text-align:left;'>
<b>NeuLogic<span style={tmStyle}>™</span> Passkey Generator</b> is a powerful yet simple tool designed to help you create strong, secure passwords for all your online accounts and sensitive applications.<br/><br/>
In today's digital world, using unique and complex passwords is essential for protecting your personal information. Our clean, intuitive interface makes generating high-quality passwords easier than ever.<br/><br/>
<b>Key Features:</b><ul>
<li>Customizable Password Generation – Create passwords with precise control over length, character sets, and complexity</li>
<li>Pronounceable Passwords – Generate memorable yet secure passwords that are easier to remember</li>
<li>Multiple Character Sets – Include uppercase letters, lowercase letters, numbers, and special characters</li>
<li>PIN Generation – Create numeric-only passwords suitable for PINs and access codes</li>
<li>UUID Generation – Generate standard Version 4 UUIDs for development or identification purposes</li>
<li>Password Formatting – Split passwords into segments for better readability with customizable separators</li>
<li>Excluded Characters – Specify characters you don't want included in your passwords</li>
<li>Clipboard Integration – Automatically copy passwords to clipboard for easy use</li>
<li>Password Strength Indicator – Visual feedback on password security level</li>
<li>Clean, Modern Interface – Elegant design that's easy to use</li>
<li>No Internet Connection Required – Generate passwords offline for complete privacy</li>
</ul>
<b>Perfect For:</b><ul>
<li>Creating strong, unique passwords for all your accounts</li>
<li>Generating secure codes for two-factor authentication</li>
<li>Developers needing test credentials or UUIDs</li>
<li>IT professionals managing multiple systems</li>
<li>Anyone concerned about online security</li>
</ul>
Your digital security starts with strong passwords. Get started today with NeuLogic<span style={tmStyle}>™</span> Passkey Generator!<br/><br/>
<b>App Features:</b><ul>
<li>Generate strong, secure passwords with customizable options</li>
<li>Create pronounceable passwords that are easier to remember</li>
<li>Generate numeric PINs and UUIDs</li>
<li>Automatic clipboard copying for convenience</li>
<li>Password strength indicator</li>
<li>Customizable formatting with separators</li>
<li>No internet connection required – complete privacy</li>
<li>Modern, intuitive interface</li>
</ul>
<b>System Requirements:</b><ul>
<li>Windows 10 or higher</li>
<li>70 MB of free disk space</li>
<li>512 MB RAM</li>
</ul>
</div>`,
    price: 29.95,
    stripeLink: "https://buy.stripe.com/bIYdSecOE7Np7QIeUW"
  },
  {
    id: 'sandy',
    name: 'Sandy',
    shortDesc: 'Visual UI layout prototyping tool',
    heroImage: '/Graphics/Product Screenshots/sandy_01.png',
    screenshots: [
      '/Graphics/Product Screenshots/sandy_01.png',
      '/Graphics/Product Screenshots/sandy_02.png',
      '/Graphics/Product Screenshots/sandy_03.png',
      '/Graphics/Product Screenshots/sandy_04.png',
      '/Graphics/Product Screenshots/sandy_05.png',
      '/Graphics/Product Screenshots/sandy_06.png',
      '/Graphics/Product Screenshots/sandy_07.png',
      '/Graphics/Product Screenshots/sandy_08.png',
      '/Graphics/Product Screenshots/sandy_09.png',
      '/Graphics/Product Screenshots/sandy_10.png',
      '/Graphics/Product Screenshots/sandy_11.png',
    ],
    download: '/downloads/NeuLogicSandy.zip',
    description: `<div style='text-align:left;'>
<b>NeuLogic<span style={tmStyle}>™</span> Sandy</b> is a lightweight UI layout design tool that lets you quickly prototype application interfaces by placing, moving, and resizing common UI elements on a configurable canvas — no coding required.<br/><br/>
Whether you're sketching a new dialog, planning a settings screen, or communicating a layout idea to a developer, Sandy gives you a clean, distraction-free sandbox to work in.<br/><br/>
<b>Key Features:</b><ul>
<li>14 UI Element Types – Button, Label, Input Field, Checkbox, Radio Button, ComboBox, GroupBox, TextEdit, ProgressBar, Slider, SpinBox, Frame, Hamburger Btn, and Kebab Btn</li>
<li>Smart Snap Alignment – Orange guide lines appear automatically when element edges or centers align, letting you place elements precisely without manual coordinate entry</li>
<li>Overlap Prevention – Elements cannot overlap each other; Sandy finds an open position automatically</li>
<li>Configurable Canvas – Set any width and height, choose a corner radius, and toggle a Windows-style title bar on or off</li>
<li>Per-Element Properties – Control exact position, size, label text, and corner radius for every element with live preview</li>
<li>Label Auto-Sizing – Label, Checkbox, and Radio Button elements automatically resize their width to fit the text you type</li>
<li>Undo / Redo – 999-step undo and redo history covering all committed actions</li>
<li>Duplicate and Delete – Quickly clone any element or remove it with a single action</li>
<li>Full Keyboard Shortcuts – Add any element type with Alt+letter, duplicate with Ctrl+D, delete with Del, open properties with Ctrl+P, undo with Ctrl+Z, redo with Ctrl+Y</li>
<li>Container Elements – Frame and GroupBox stack behind other elements to visually group related controls</li>
<li>No Internet Connection Required – Works entirely offline</li>
</ul>
<b>Perfect For:</b><ul>
<li>Developers sketching dialog or screen layouts before writing code</li>
<li>Designers communicating UI structure to a development team</li>
<li>Product managers prototyping feature layouts quickly</li>
<li>Anyone who needs to think through an interface arrangement visually</li>
</ul>
Stop describing layouts in words. Start showing them. Get started today with NeuLogic<span style={tmStyle}>™</span> Sandy!<br/><br/>
<b>System Requirements:</b><ul>
<li>Windows 10 or higher</li>
<li>50 MB of free disk space</li>
<li>256 MB RAM</li>
</ul>
</div>`,
    price: 29.95,
    stripeLink: "https://buy.stripe.com/9B6dRbbYZeY40jk4u9ebu0g"
  },
  {
    id: 'screenannotator',
    name: 'Screen Annotator',
    shortDesc: 'Place arrows, guides, and highlights anywhere on screen',
    heroImage: '/Graphics/Product Screenshots/ScreenAnnotator_01.png',
    screenshots: [
      '/Graphics/Product Screenshots/ScreenAnnotator_01.png',
      '/Graphics/Product Screenshots/ScreenAnnotator_02.png',
      '/Graphics/Product Screenshots/ScreenAnnotator_03.png',
      '/Graphics/Product Screenshots/ScreenAnnotator_04.png',
      '/Graphics/Product Screenshots/ScreenAnnotator_05.png',
      '/Graphics/Product Screenshots/ScreenAnnotator_06.png',
    ],
    download: '/downloads/NeuLogicScreenAnnotator.zip',
    description: `<div style='text-align:left;'>
<b>NeuLogic<span style={tmStyle}>™</span> Screen Annotator</b> is a flexible screen annotation tool designed for presentations, demonstrations, and highlighting important information across multiple monitors.<br/><br/>
Our intuitive interface lets you quickly add arrow pointers, comment balloons, and row highlighters that remain visible even when working between different applications. This makes it perfect for tracking specific rows in spreadsheets like Microsoft Excel, following important text in documents, or highlighting reference information on one monitor while actively working on another. Since all elements remain visible above other applications, you'll never lose track of critical information, even when switching focus between windows.<br/><br/>
<b>Key Features:</b><ul>
<li><b>Customizable Arrow Pointers</b> - Create directional arrows with precise control over direction, color, and style</li>
<li><b>Comment Balloons</b> - Add editable text comments to explain important details on your screen</li>
<li><b>Row Highlighters</b> - Create semi-transparent highlighting bars across the screen to emphasize content</li>
<li><b>Screen LaserLines</b> - Create full-screen vertical or horizontal reference lines for alignment or visual guides. Choose how many vertical or horizontal lines to display.</li>
<li><b>Multiple Directional Options</b> - Place arrows and comments pointing up, down, left, or right</li>
<li><b>Color Customization</b> - Choose custom colors for all annotation elements</li>
<li><b>Arrow Style Options</b> - Select between solid or outline arrow styles</li>
<li><b>Global Controls</b> - Hide, show, or close all annotations at once</li>
<li><b>System Tray Integration</b> - Access controls quickly during presentations</li>
<li><b>Temporary Position Memory</b> - Remembers annotation positions only if enabled during previous session, resets on next launch unless re-enabled</li>
<li><b>Background Mode</b> - Option to keep annotations active after closing, must be re-enabled manually each time</li>
<li><b>Clean, Modern Interface</b> - Elegant design that's easy to use</li>
<li><b>Always-on-Top Display</b> - Annotations remain visible above other applications</li>
</ul>
<b>Perfect For:</b><ul>
<li>Live presentations and demonstrations</li>
<li>Educational screencasts and tutorials</li>
<li>Technical support sessions</li>
<li>Highlighting important screen elements</li>
<li>Training videos and documentation</li>
<li>Remote collaboration and instruction</li>
<li>Software demonstrations</li>
<li>Visual explanations</li>
</ul>
Your communication effectiveness starts with clear visual cues. Get started today with NeuLogic<span style={tmStyle}>™</span> Screen Annotator!<br/><br/>
<b>App Features:</b><ul>
<li>Create arrow pointers with customizable directions, colors, and styles</li>
<li>Add text comment balloons positioned in any direction</li>
<li>Generate row highlighters across the screen</li>
<li>Add full-length vertical or horizontal screen LaserLines</li>
<li>Set number of LaserLines to display with fine-tuned spacing</li>
<li>Select custom colors for all annotation elements</li>
<li>Hide, show, or close all annotations with one click</li>
<li>Run in background with system tray access</li>
<li>Remember positions between sessions</li>
<li>Modern, intuitive interface</li>
<li>All elements stay on top of other windows</li>
</ul>
<b>System Requirements:</b><ul>
<li>Windows 10 or higher</li>
<li>50 MB of free disk space</li>
<li>256 MB RAM</li>
</ul>
</div>`,
    price: 24.95,
    stripeLink: "https://buy.stripe.com/6oE29w6qg6Jlb2U4gn"
  },
  {
    id: 'screenrecorder',
    name: 'Screen Recorder',
    shortDesc: 'Controlled frame-based screen capture',
    heroImage: '/Graphics/Product Screenshots/ScreenRecorder_01.png',
    screenshots: [
      '/Graphics/Product Screenshots/ScreenRecorder_01.png',
      '/Graphics/Product Screenshots/ScreenRecorder_02.png',
      '/Graphics/Product Screenshots/ScreenRecorder_03.png',
      '/Graphics/Product Screenshots/ScreenRecorder_04.png',
      '/Graphics/Product Screenshots/ScreenRecorder_05.png',
      '/Graphics/Product Screenshots/ScreenRecorder_06.png',
    ],
    download: '/downloads/NeuLogicScreenRecorder.zip',
    description: `<div style='text-align:left;'>
<b>NeuLogic<span style={tmStyle}>™</span> Screen Recorder</b> is an efficient screen capture utility designed for educators, technical trainers, content creators, and anyone needing to document on-screen activity. With its frame-by-frame recording approach, it provides exceptional control over capture quality while maintaining small file sizes.<br/><br/>
In today's visual communication environment, effective screen recordings are essential for tutorials, demonstrations, and training materials. Our streamlined interface makes the recording process simple with intuitive controls and real-time status updates.<br/><br/>
<b>Key Features:</b><ul>
<li>Frame-Based Recording – Captures screen as a sequence of images for maximum flexibility</li>
<li>Customizable Lead Time – Set countdown timers (3-30 seconds) before recording begins</li>
<li>Adjustable Frame Rate – Choose from presets between 1-60 FPS to balance quality and file size</li>
<li>Flexible Duration – Set recording length from 1-300 seconds</li>
<li>Visual Countdown – Animated overlay shows remaining time before recording starts</li>
<li>Real-Time Status Updates – Progress tracking during recording and saving</li>
<li>System Tray Integration – Control recordings from the system tray icon</li>
<li>Global Hotkeys – Start/stop recording with keyboard shortcuts</li>
<li>Automatic File Organization – Recordings saved with timestamps in dedicated folders</li>
<li>Multi-Monitor Support – Record from any connected display</li>
<li>Low Resource Impact – Optimized for minimal system overhead</li>
<li>Completely Offline Operation – No internet connection required for total privacy</li>
</ul>
<b>Perfect For:</b><ul>
<li>Creating software tutorials and demonstrations</li>
<li>Recording training materials and educational content</li>
<li>Documenting bugs or technical issues</li>
<li>Capturing presentation slides with precise timing</li>
<li>Creating animated GIFs from screen recordings</li>
<li>Technical support and troubleshooting documentation</li>
<li>Process documentation for standard operating procedures</li>
<li>Gameplay recording with controlled frame rates</li>
</ul>
Take control of your screen recording process with NeuLogic<span style={tmStyle}>™</span> Screen Recorder - the professional way to capture exactly what you need!<br/><br/>
<b>App Features:</b><ul>
<li>Record screen as a sequence of image frames</li>
<li>Set lead time countdown before recording starts</li>
<li>Choose frame rate from 1-60 FPS presets</li>
<li>Adjust recording duration from 1-300 seconds</li>
<li>View progress and status in real-time log</li>
<li>Control recordings via system tray</li>
<li>Use global hotkey shortcuts (Ctrl+Alt+R)</li>
<li>Automatic timestamp-based file organization</li>
<li>Complete offline operation for privacy</li>
<li>Low system resource utilization</li>
</ul>
<b>System Requirements:</b><ul>
<li>Windows 10 or higher</li>
<li>50 MB of free disk space</li>
<li>256 MB RAM</li>
</ul>
</div>`,
    price: 14.95,
    stripeLink: "https://buy.stripe.com/cN26pMaGw6Jl7QI6ot"
  },
  {
    id: 'workdowntimer',
    name: 'WorkDown Timer™',
    shortDesc: 'Focused countdown productivity timer',
    heroImage: '/Graphics/Product Screenshots/WorkDownTimer_01.png',
    screenshots: [
      '/Graphics/Product Screenshots/WorkDownTimer_01.png',
      '/Graphics/Product Screenshots/WorkDownTimer_02.png',
      '/Graphics/Product Screenshots/WorkDownTimer_03.png',
      '/Graphics/Product Screenshots/WorkDownTimer_04.png',
      '/Graphics/Product Screenshots/WorkDownTimer_05.png',
      '/Graphics/Product Screenshots/WorkDownTimer_06.png',
      '/Graphics/Product Screenshots/WorkDownTimer_07.png',
      '/Graphics/Product Screenshots/WorkDownTimer_08.png',
      '/Graphics/Product Screenshots/WorkDownTimer_09.png',
      '/Graphics/Product Screenshots/WorkDownTimer_10.png',
      '/Graphics/Product Screenshots/WorkDownTimer_11.png',
      '/Graphics/Product Screenshots/WorkDownTimer_12.png',
      '/Graphics/Product Screenshots/WorkDownTimer_13.png',
      '/Graphics/Product Screenshots/WorkDownTimer_14.png',
    ],
    download: '/downloads/NeuLogicWorkDownTimer.zip',
    description: `<div style='text-align:left;'>
<b>NeuLogic<span style={tmStyle}>™</span> WorkDown Timer<span style={tmStyle}>™</span></b> is a specialized countdown timer designed for professionals, students, and anyone who wants to improve productivity through effective time management. With an intuitive interface and visual progress indicators, it helps you maintain focus during work sessions and ensures proper breaks to maximize efficiency.<br/><br/>
In today's distraction-filled environment, maintaining productivity requires deliberate time management. Our streamlined timer provides a simple yet powerful way to implement techniques like Pomodoro or time-blocking, helping you stay on task and track your work intervals throughout the day.<br/><br/>
<b>Key Features:</b><ul>
<li>Visual Countdown Display – Clear, prominent timer with customizable appearance</li>
<li>Flexible Time Intervals – Set any duration from minutes to hours for perfect work/break cycles</li>
<li>Always-on-Top Mode – Keep the timer visible regardless of your active application</li>
<li>System Tray Integration – Access controls discreetly during focused work</li>
<li>Session Tracking – Monitor your work patterns and productivity trends</li>
<li>Customizable Appearance – Adjust the timer's look to suit your desktop environment</li>
<li>Low-Distraction Design – Minimal interface that won't pull focus from your work</li>
<li>Start/Pause/Reset Controls – One-click operation for seamless workflow management</li>
<li>Optional Alerts – Gentle notifications when your timer completes</li>
<li>Multiple Timer Presets – Save frequently used intervals for quick access</li>
<li>Global Hotkeys – Control the timer without switching applications</li>
<li>No Internet Connection Required – Complete privacy with offline operation</li>
</ul>
<b>Perfect For:</b><ul>
<li>Implementing the Pomodoro Technique for focused work sessions</li>
<li>Time-blocking your day for maximum productivity</li>
<li>Tracking billable hours for client projects</li>
<li>Managing meeting and presentation timeframes</li>
<li>Limiting time spent on specific tasks</li>
<li>Ensuring proper breaks for mental refreshment</li>
<li>Students needing to allocate study time effectively</li>
<li>Anyone who wants to improve time awareness and productivity</li>
</ul>
Take control of your time and boost your productivity with NeuLogic<span style={tmStyle}>™</span> WorkDown Timer™ - the professional's choice for focused work sessions!<br/><br/>
<b>App Features:</b><ul>
<li>Create customizable countdown timers</li>
<li>Set time intervals from minutes to hours</li>
<li>Keep timer visible above other applications</li>
<li>Control timer from system tray</li>
<li>Track completed work sessions</li>
<li>Adjust timer appearance to match your workspace</li>
<li>Use preset time intervals for consistency</li>
<li>Control timer with global keyboard shortcuts</li>
<li>Receive optional alerts when timer completes</li>
<li>No internet connection required - complete privacy</li>
<li>Lightweight design with minimal system impact</li>
</ul>
<b>System Requirements:</b><ul>
<li>Windows 10 or higher</li>
<li>30 MB of free disk space</li>
<li>128 MB RAM</li>
</ul>
</div>`,
    price: 14.95,
    stripeLink: "https://buy.stripe.com/14k5lI5mcc3F2wo7sy"
  },
  {
	id: 'applauncher',
	name: 'App Launcher',
    shortDesc: 'Launch apps individually\nor in a group',
	heroImage: '/Graphics/Product Screenshots/AppLauncher_001.png',
	screenshots: [
    '/Graphics/Product Screenshots/AppLauncher_001.png',
    '/Graphics/Product Screenshots/AppLauncher_002.png',
    '/Graphics/Product Screenshots/AppLauncher_003.png',
    '/Graphics/Product Screenshots/AppLauncher_004.png',
	],
	download: '/downloads/NeuLogicAppLauncher.zip',
	description: `<div style='text-align:left;'>
<p><b>NeuLogic™ App Launcher</b> transforms the way users access their most important programs, files, and folders by organizing them into smart, customizable sets that launch instantly with a single click.</p>
<p>No more hunting through Start menus, taskbars, and folders. Whether it's a "Morning Routine" set that opens email, calendar, and chat apps, or a "Development" set that launches an IDE, terminal, and documentation - App Launcher gets users working faster.</p>
<p>The clean, intuitive interface allows organizing up to four different sets of applications, each with its own custom name. Switch between sets instantly, launch individual apps with dedicated Open buttons, or use the Launch All feature to open everything in a set at once.</p>

<b>Key Features:</b>
<ul>
<li>Four Customizable Sets — Organize apps by project, time of day, or workflow</li>
<li>Quick Launch Buttons — Open individual apps instantly without switching windows</li>
<li>Launch All — Start entire workflows with one click</li>
<li>Multiple Launch Types — Default, Explorer, PowerShell, and Notepad++ multi-instance</li>
<li>Drag & Drop Support — Add files, folders, or programs by dragging them into the list</li>
<li>Smart Auto-Sort — New items automatically organize alphabetically, or arrange manually</li>
<li>Visual App Icons — See exactly what's launching with familiar file icons</li>
<li>Enable/Disable Apps — Temporarily skip apps without removing them from sets</li>
<li>Custom Set Names — Label sets "Work", "Gaming", "Morning", or anything meaningful</li>
<li>Position Memory — Window opens exactly where it was left, even across multiple monitors</li>
<li>Start with Windows — Optionally launch with the system for instant availability</li>
<li>Right-Click Options — Edit, disable, or sort apps with convenient context menus</li>
</ul>

<b>Perfect For:</b>
<ul>
<li>Developers who need quick access to IDEs, terminals, and documentation</li>
<li>Designers switching between creative applications and asset folders</li>
<li>Students organizing study materials and research tools</li>
<li>Remote workers with morning, afternoon, and evening workflows</li>
<li>Anyone tired of clicking through menus to find programs</li>
<li>Power users who value efficiency and organization</li>
</ul>
<p>Stop clicking around. Start launching smarter. Get <b>NeuLogic™ App Launcher</b> — the personalized productivity command center!</p>

<b>System Requirements:</b>
<ul>
<li>Windows 10 or higher</li>
<li>50 MB of free disk space</li>
<li>256 MB RAM</li>
</ul>
</div>`,
    price: 0,
    stripeLink: ""
  },
  {
	id: 'caffeinefree',
	name: 'Caffeine-Free™',
	shortDesc: 'Prevents computer\nsleep when idle',
	heroImage: '/Graphics/Product Screenshots/CaffeineFree_01.png',
	screenshots: [
	'/Graphics/Product Screenshots/CaffeineFree_01.png',
	'/Graphics/Product Screenshots/CaffeineFree_02.png',
	],
	download: '/downloads/NeuLogicCaffeineFree.zip',
	description: `<div style='text-align:left;'>
<p><b>Caffeine-Free<span style={tmStyle}>™</span></b> is a clean alternative to traditional sleep prevention apps that prevents your computer from sleeping without the annoying side effects of fake keystrokes or system interference.</p>
<p>Unlike other similar apps that constantly fight your system or inject disruptive characters into your work, Caffeine-Free intelligently monitors your activity and only prevents sleep when you're actually away from your computer. This means no more random "~" characters appearing in your terminals or command prompts, and no interference with your active work.</p>
<p>The app runs silently in your system tray with a simple green/gray monitor icon indicating its status. You can easily toggle between Active and Paused modes, or set intelligent timers to automatically switch states after specified durations.</p>

<b>Key Features:</b>
<ul>
<li>Smart Activity Detection — Only prevents sleep when you're inactive for 55+ seconds</li>
<li>Non-Invasive Operation — Uses proper Windows APIs instead of fake keystrokes</li>
<li>System Tray Integration — Clean, minimal interface that stays out of your way</li>
<li>Intelligent Timers — Set duration-based switching between Active and Paused modes</li>
<li>Multiple Timer Options — Choose from 15 minutes to 8 hours for automatic state changes</li>
<li>Live Timer Display — See countdown timers directly in the context menu</li>
<li>Double-Click Toggle — Quick switching between Active/Paused with tray icon double-click</li>
<li>Automatic Resume — Remembers if you left it Active or Paused and resumes that way on reboot</li>
<li>Professional Design — Clean NeuLogic™ styling consistent with professional applications</li>
<li>No Console Interference — Works perfectly for developers and power users</li>
<li>Single Instance Protection — Prevents conflicts from multiple running copies</li>
</ul>

<b>Perfect For:</b>
<ul>
<li>Software developers working with terminals and command prompts</li>
<li>Long-running downloads, uploads, or file transfers</li>
<li>Presentations and demonstrations</li>
<li>Remote work sessions and video calls</li>
<li>Overnight processing tasks</li>
<li>Anyone frustrated with invasive Caffeine alternatives</li>
</ul>

<p>Stop fighting with disruptive sleep prevention tools. Get Caffeine-Free<span style={tmStyle}>™</span> — the professional's choice for intelligent, non-invasive computer wake management!</p>

<b>System Requirements:</b>
<ul>
<li>Windows 10 or higher</li>
<li>25 MB of free disk space</li>
<li>256 MB RAM</li>
</ul>
</div>`,
    price: 0,
    stripeLink: ""
  },
  {
    id: "calculator",
    name: "Calculator",
    shortDesc: 'Basic desktop calculator',
    heroImage: '/Graphics/Product Screenshots/calculator_002.png',
    screenshots: [
      '/Graphics/Product Screenshots/calculator_001.png',
      '/Graphics/Product Screenshots/calculator_002.png',
      '/Graphics/Product Screenshots/calculator_003.png',
      '/Graphics/Product Screenshots/calculator_004.png',
    ],
    download: '/downloads/NeuLogicCalculator.zip',
    description: `<div style='text-align:left;'>
<b>NeuLogic<span style={tmStyle}>™</span> Calculator</b> is a compact desktop calculator built for fast, everyday arithmetic without clutter, distractions, or bloated extras. It opens quickly, stays out of the way, and gives a clean, familiar calculator experience for basic calculations.<br/><br/>
Designed with a polished desktop-style interface, Calculator supports both mouse and keyboard input, making it easy to work the way that feels most natural. It also includes quick numeric copy and paste support, so values can be moved in and out without unnecessary steps.<br/><br/>
<b>Key Features:</b><ul>
<li><b>Basic arithmetic</b> — Addition, subtraction, multiplication, and division</li>
<li><b>Keyboard support</b> — Use number keys and operators directly from the keyboard</li>
<li><b>Mouse-friendly layout</b> — Clear button layout for quick everyday use</li>
<li><b>Copy and paste</b> — Copy numeric values and paste cleaned numeric input</li>
<li><b>Right-click menu</b> — Fast access to Copy, Paste, and Select All</li>
<li><b>Compact design</b> — Small footprint that fits easily on the desktop</li>
<li><b>Clean interface</b> — Simple, polished look without unnecessary extras</li>
<li><b>Lightweight</b> — Opens fast and stays responsive</li>
</ul>
<b>Perfect For:</b><ul>
<li>Everyday desktop calculations</li>
<li>Quick number checks while working in other apps</li>
<li>Users who want a simple calculator without clutter</li>
<li>Anyone who prefers a small dedicated calculator window</li>
</ul>
<b>System Requirements:</b><ul>
<li>Windows 10 or higher</li>
<li>50 MB of free disk space</li>
<li>Minimal memory usage</li>
</ul>
</div>`,
    price: 0,
    stripeLink: ""
  },
  {
    id: "colorpicker",
    name: "Color Picker",
    shortDesc: 'Precision screen color sampler',
    heroImage: '/Graphics/Product Screenshots/ColorPicker_001.png',
    screenshots: [
      '/Graphics/Product Screenshots/ColorPicker_001.png',
      '/Graphics/Product Screenshots/ColorPicker_002.png',
      '/Graphics/Product Screenshots/ColorPicker_003.png',
      '/Graphics/Product Screenshots/ColorPicker_004.png',
    ],
    download: '/downloads/NeuLogicColorPicker.zip',
    description: `<div style='text-align:left;'>
<b>NeuLogic<span style={tmStyle}>™</span> Color Picker</b> is a professional color picker designed for designers, developers, and anyone who works with color. Capture any color from anywhere on your screen with pixel-perfect precision, then fine-tune it with an intuitive shade comparison slider.<br/><br/>
Unlike outdated color pickers with clunky interfaces and limited functionality, Color Picker features a sharp 1px crosshair cursor for precise targeting, real-time color preview as you move across the screen, and full multi-monitor support. The dynamic shade slider shows your exact color gradient from dark to light—not a generic grayscale bar.<br/><br/>
<b>Key Features:</b><ul>
<li><b>Global eyedropper</b> — Pick colors from anywhere on any screen in your multi-monitor setup</li>
<li><b>Pixel-perfect precision</b> — Sharp 1px crosshair cursor with red center dot for accurate targeting</li>
<li><b>Real-time preview</b> — See colors update live as you move across the screen</li>
<li><b>Shade comparison</b> — Slider shows actual color gradient from darker to lighter shades</li>
<li><b>Right-click to copy</b> — Quickly copy any value to clipboard with visual confirmation</li>
<li><b>Original & Adjusted views</b> — Compare your picked color with adjusted shade side-by-side</li>
<li><b>Modern interface</b> — Clean, professional design that doesn't look like it's from 2005</li>
<li><b>Lightweight</b> — Opens instantly, no bloat, no unnecessary features</li>
<li><b>Free</b> — No purchase, no subscription, no registration</li>
</ul>
<b>Perfect For:</b><ul>
<li>Web designers matching colors from mockups</li>
<li>Developers grabbing hex codes from any application</li>
<li>Digital artists sampling colors from reference images</li>
<li>UI/UX designers creating consistent color palettes</li>
<li>Anyone tired of squinting at blurry crosshairs in outdated tools</li>
</ul>
<b>System Requirements:</b><ul>
<li>Windows 10 or higher</li>
<li>50 MB of free disk space</li>
<li>256 MB RAM</li>
</ul>
</div>`,
    price: 0,
    stripeLink: ""
  },
  {
    id: "imagefloater",
    name: "Image Floater™",
    shortDesc: 'Always-on-top floating image viewer',
    heroImage: '/Graphics/Product Screenshots/ImageFloater_001.png',
    screenshots: [
      '/Graphics/Product Screenshots/ImageFloater_001.png',
      '/Graphics/Product Screenshots/ImageFloater_002.png',
      '/Graphics/Product Screenshots/ImageFloater_003.png',
      '/Graphics/Product Screenshots/ImageFloater_004.png',
      '/Graphics/Product Screenshots/ImageFloater_005.png',
      '/Graphics/Product Screenshots/ImageFloater_006.png',
      '/Graphics/Product Screenshots/ImageFloater_007.png',
    ],
    download: '/downloads/NeuLogicImageFloater.zip',
    description: `<div style='text-align:left;'>
<b>NeuLogic<span style={tmStyle}>™</span> Image Floater<span style={tmStyle}>™</span></b> displays images in a borderless, always-on-top window that floats over all applications. Perfect for reference images, design comparisons, or keeping visuals accessible while working in other programs.<br/><br/>

Right-click any image file and select "Open with NeuLogic™ Image Floater™" to instantly display it as a floating overlay. Zoom with the scroll wheel, drag to reposition, and resize to any percentage—all while keeping the image visible above your work.<br/><br/>

<b>Key Features:</b><ul>
<li><b>Always-on-top display</b> — Image stays visible over all windows</li>
<li><b>Borderless floating window</b> — Clean, minimal appearance</li>
<li><b>Scroll wheel zoom</b> — Smooth zooming centered on cursor position</li>
<li><b>Drag to reposition</b> — Move the image anywhere on screen</li>
<li><b>Preset resize options</b> — Quick resize to 25%, 50%, 75%, 100%, 125%, 150%, 200%, 250%, 300%</li>
<li><b>Flip and rotate</b> — Horizontal/vertical flip and rotation options</li>
<li><b>Paste from clipboard</b> — Display images directly from clipboard</li>
<li><b>Context menu integration</b> — Add "Open with Image Floater" to Windows right-click menu</li>
<li><b>Multi-monitor support</b> — Works across all connected displays</li>
<li><b>Lightweight</b> — Fast loading, minimal resource usage</li>
<li><b>Free</b> — No purchase, no subscription, no registration</li>
</ul>

<b>Perfect For:</b><ul>
<li>Designers referencing mockups while working</li>
<li>Developers comparing UI implementations to designs</li>
<li>Artists using reference images</li>
<li>Anyone who needs to keep an image visible while working</li>
<li>Presentations and demonstrations</li>
</ul>

<b>System Requirements:</b><ul>
<li>Windows 10 or higher</li>
<li>50 MB of free disk space</li>
<li>256 MB RAM</li>
</ul>
</div>`,
    price: 0,
    stripeLink: ""
  },
  {
    id: 'imagebgviewer',
    name: 'Image BG Viewer',
    shortDesc: 'Test images on custom backgrounds',
    heroImage: '/Graphics/Product Screenshots/ImageBackgroundViewer_01.png',
    screenshots: [
      '/Graphics/Product Screenshots/ImageBackgroundViewer_01.png',
      '/Graphics/Product Screenshots/ImageBackgroundViewer_02.png',
      '/Graphics/Product Screenshots/ImageBackgroundViewer_03.png',
      '/Graphics/Product Screenshots/ImageBackgroundViewer_04.png',
      '/Graphics/Product Screenshots/ImageBackgroundViewer_05.png',
      '/Graphics/Product Screenshots/ImageBackgroundViewer_06.png',
      '/Graphics/Product Screenshots/ImageBackgroundViewer_07.png',
      '/Graphics/Product Screenshots/ImageBackgroundViewer_08.png',
      '/Graphics/Product Screenshots/ImageBackgroundViewer_09.png',
	  '/Graphics/Product Screenshots/ImageBackgroundViewer_10.png',
    ],
    download: '/downloads/NeuLogicImageBackgroundViewer.zip',
    description: `<div style='text-align:left;'>
<p><b>NeuLogic<span style={tmStyle}>™</span> Image Background Viewer</b> is designed for designers, developers, and digital artists who need to evaluate images against various background colors. This lightweight yet powerful tool provides a simple way to view any image on a custom-colored backdrop in fullscreen mode, making it ideal for checking transparency, evaluating borders, and assessing visual appearance.</p>
<p>In today's visual design environment, how an image looks against different backgrounds is crucial for ensuring quality across various platforms and presentations. The clean minimalist interface makes it easy to select the desired background color and image, then view it in a distraction-free environment with convenient viewing controls.</p>

<b>Key Features:</b>
<ul>
<li>Custom Background Colors — Choose any backdrop color to test image appearance</li>
<li>Fullscreen Viewing — See the images at maximum size without interface distractions</li>
<li>Interactive Resizing — Use the mouse wheel to dynamically resize images during viewing</li>
<li>Size Feedback — Get real-time information about image dimensions and scale percentage</li>
<li>Simple Controls — Intuitive interface with minimal learning curve</li>
<li>Consistent Centering — Images always remain perfectly centered for proper evaluation</li>
<li>Transparency Support — Ideal for checking PNG and other formats with transparency</li>
<li>Distraction-Free Mode — Focus solely on the image against the selected background</li>
</ul>

<b>Perfect For:</b>
<ul>
<li>Designers checking image transparency and borders</li>
<li>Developers evaluating assets for applications and websites</li>
<li>Digital artists assessing artwork against different backgrounds</li>
<li>Content creators preparing images for various platforms</li>
<li>Anyone needing to evaluate how images appear on colored backgrounds</li>
</ul>

<p>Improve your image assessment process with NeuLogic<span style={tmStyle}>™</span> Image Background Viewer — the professional's choice for visual evaluation!</p>

<b>System Requirements:</b>
<ul>
<li>Windows 10 or higher</li>
<li>50 MB of free disk space</li>
<li>256 MB RAM</li>
</ul>
</div>`,
    price: 0,
    stripeLink: ""
  },
  {
    id: 'pricecalculator',
    name: 'Price Calculator',
    shortDesc: 'Tax, discount, and return calculator',
    heroImage: '/Graphics/Product Screenshots/PriceCalculator_01.png',
    screenshots: [
      '/Graphics/Product Screenshots/PriceCalculator_01.png'],
    download: '/downloads/NeuLogicPriceCalculator.zip',
    description: `<div style='text-align:left;'>
<b>NeuLogic<span style={tmStyle}>™</span> Price Calculator</b> is an intuitive desktop application designed to help business owners, retail staff, and anyone needing to manage pricing calculations efficiently. With its straightforward interface, you can easily track purchases and returns, apply discounts, calculate taxes, and generate clear reports.<br/><br/>
In today's business environment, accurately calculating prices, taxes, and discounts is essential for proper record-keeping and customer service. Our clean, tabular interface makes managing these calculations simple with real-time totals and comprehensive reporting.<br/><br/>
<b>Key Features:</b><ul>
<li>Dual Price Entry Options – Enter prices either with tax included or before tax for maximum flexibility</li>
<li>Automatic Tax Calculations – Configure your local tax rate once and let the application handle all calculations</li>
<li>Purchase and Return Tracking – Record both purchases and returns with clear visual distinction</li>
<li>Flexible Discount Options – Apply discounts as either percentage or fixed dollar amounts</li>
<li>Tax Exemption Support – Toggle tax-exempt status for eligible items or customers</li>
<li>Quantity Management – Track multiple quantities of the same item with ease</li>
<li>Real-time Totals – See running totals that update automatically with each entry</li>
<li>Print-Ready Reports – Generate formatted reports of all transactions</li>
<li>Clean, Intuitive Interface – Straightforward design with visual cues for different transaction types</li>
<li>Dynamic Row Styling – Alternating row colors and highlighted returns for better readability</li>
<li>Fully Offline Operation – Complete privacy with no internet connection required</li>
</ul>
<b>Perfect For:</b><ul>
<li>Small business owners calculating pricing and taxes</li>
<li>Retail staff needing to process and track sales</li>
<li>Service providers creating cost estimates</li>
<li>Finance professionals analyzing purchase data</li>
<li>Event planners managing budgets and expenses</li>
<li>Anyone needing to calculate before/after tax prices quickly</li>
</ul>
Start simplifying your price calculations today with NeuLogic<span style={tmStyle}>™</span> Price Calculator!<br/><br/>
<b>App Features:</b><ul>
<li>Calculate prices with or without tax included</li>
<li>Track both purchases and returns in one interface</li>
<li>Apply percentage or fixed discounts</li>
<li>Handle tax-exempt items or transactions</li>
<li>Calculate totals automatically</li>
<li>Generate printable reports</li>
<li>Clearly visualize different transaction types</li>
<li>Customizable tax rate settings</li>
<li>No internet connection required – complete privacy</li>
<li>Simple, straightforward interface</li>
</ul>
<b>System Requirements:</b><ul>
<li>Windows 10 or higher</li>
<li>50 MB of free disk space</li>
<li>256 MB RAM</li>
</ul>
</div>`,
    price: 0,
    stripeLink: ""
  },
  {
    id: 'screenruler',
    name: 'Screen Ruler',
    shortDesc: 'Pixel-accurate on-screen measurement',
    heroImage: '/Graphics/Product Screenshots/ScreenRuler_001.png',
    screenshots: [
      '/Graphics/Product Screenshots/ScreenRuler_001.png',
      '/Graphics/Product Screenshots/ScreenRuler_002.png',
      '/Graphics/Product Screenshots/ScreenRuler_003.png',
      '/Graphics/Product Screenshots/ScreenRuler_004.png',
      '/Graphics/Product Screenshots/ScreenRuler_005.png',
      '/Graphics/Product Screenshots/ScreenRuler_006.png',
      '/Graphics/Product Screenshots/ScreenRuler_007.png',
      '/Graphics/Product Screenshots/ScreenRuler_008.png',
      '/Graphics/Product Screenshots/ScreenRuler_009.png',
      '/Graphics/Product Screenshots/ScreenRuler_010.png',
    ],
    download: '/downloads/NeuLogicScreenRuler.zip',
    description: `<div style='text-align:left;'>
<b>NeuLogic<span style={tmStyle}>™</span> Screen Ruler</b> is a sleek, always-on-top measurement tool for designers, developers, and anyone needing pixel-accurate spacing on-screen. Place draggable laser lines over any application (across multiple monitors) and see the live distance in pixels with a mirrored readout.<br/><br/>

Choose the measurement mode that fits the job: a <b>pair</b> of lines for distance measurement, a <b>single full-screen</b> laser line (toggle vertical/horizontal), or a <b>full-screen crosshair</b> that moves as one piece.<br/><br/>

<b>Key Features:</b>
<ul>
<li>Vertical or horizontal <b>line pair</b> mode for live pixel distance measurement</li>
<li><b>Mirrored readout</b> in the main window for quick reference</li>
<li><b>Single full-screen</b> laser line mode (toggles Vertical/Horizontal)</li>
<li><b>Full-screen crosshair</b> mode (moves as one piece)</li>
<li>Drag lines with the mouse; <b>Ctrl + drag</b> moves both lines together (pair mode)</li>
<li><b>Arrow keys</b> for 1 px nudging after selecting a line</li>
<li><b>Mouse wheel</b> nudging on lines for quick adjustments</li>
<li><b>Hide/Show</b> lines without losing their positions</li>
<li><b>Clear</b> removes all lines instantly</li>
<li>Multi-monitor support (spans the full virtual desktop)</li>
<li>Clean menu access (Help / About / Exit)</li>
</ul>

<b>Perfect For:</b>
<ul>
<li>UI/UX alignment, padding, and spacing checks</li>
<li>Web/app layout verification and pixel placement debugging</li>
<li>Design comparisons across apps and monitors</li>
<li>General on-screen measurement tasks</li>
</ul>

<b>System Requirements:</b><ul>
<li>Windows 10 or higher</li>
<li>50 MB of free disk space</li>
<li>256 MB RAM</li>
</ul>
</div>`,
    price: 0,
    stripeLink: ""
  },
  {
    id: "stickynotes",
    name: "Sticky Notes",
    shortDesc: 'Desktop notes with board toggle',
    heroImage: '/Graphics/Product Screenshots/StickyNotes_001.png',
    screenshots: [
      '/Graphics/Product Screenshots/StickyNotes_001.png',
    ],
    download: '/downloads/NeuLogicStickyNotes.zip',
    description: `<div style='text-align:left;'>
<b>NeuLogic<span style={tmStyle}>™</span> Sticky Notes</b> is a modern desktop sticky notes application that combines simplicity with powerful features. Create notes instantly by clicking anywhere on screen, organize thoughts visually, and toggle between work mode and notes mode with a single click.<br/><br/>

Unlike basic sticky note apps, NeuLogic<span style={tmStyle}>™</span> Sticky Notes introduces Board Mode—click the taskbar icon to reveal all notes and enable click-to-create anywhere on screen. Click again to hide everything and return to a clean workspace.<br/><br/>

<b>Key Features:</b><ul>
<li><b>Board Mode</b> — Toggle all notes visible/hidden with one taskbar click</li>
<li><b>Click-to-create</b> — In Board Mode, click anywhere on screen to create a new note</li>
<li><b>Multiple note sizes</b> — Small, medium, large, and custom sizes</li>
<li><b>Draggable text widgets</b> — Position text anywhere within notes</li>
<li><b>Color customization</b> — Choose from multiple note colors</li>
<li><b>Always-on-top notes</b> — Notes stay visible over other windows when in Board Mode</li>
<li><b>System tray access</b> — Quick access to all functions from the system tray</li>
<li><b>Auto-save</b> — Notes are automatically saved and restored on restart</li>
<li><b>Starts with Windows</b> — Always ready when you need it</li>
<li><b>Lightweight</b> — Minimal resource usage, runs quietly in background</li>
<li><b>Free</b> — No purchase, no subscription, no registration</li>
</ul>

<b>Perfect For:</b><ul>
<li>Quick note-taking during meetings or calls</li>
<li>Visual reminders on desktop</li>
<li>Brainstorming and idea capture</li>
<li>To-do lists and task tracking</li>
<li>Anyone who wants notes that stay out of the way until needed</li>
</ul>

<b>System Requirements:</b><ul>
<li>Windows 10 or higher</li>
<li>50 MB of free disk space</li>
<li>256 MB RAM</li>
</ul>
</div>`,
    price: 0,
    stripeLink: ""
  },
  {
    id: 'textcolorvisualizer',
    name: 'Text Color Visualizer',
    shortDesc: 'Preview text and background color pairs',
    heroImage: '/Graphics/Product Screenshots/TextColorVisualizer_01.png',
    screenshots: [
      '/Graphics/Product Screenshots/TextColorVisualizer_01.png'],
    download: '/downloads/NeuLogicTextColorVisualizer.zip',
    description: `<div style='text-align:left;'>
<b>NeuLogic<span style={tmStyle}>™</span> Text Color Visualizer</b> is an intuitive application designed for web designers, document creators, and anyone who needs to find the perfect text and background color combinations. With its real-time preview and comprehensive shade options, you can quickly identify readable and aesthetically pleasing color pairs.<br/><br/>
In today's visually-driven world, finding the right color combinations is crucial for readability, accessibility, and visual impact. Our straightforward interface lets you experiment with colors and immediately see the results, helping you create professional-looking designs with confidence.<br/><br/>
<b>Key Features:</b><ul>
<li>Real-Time Preview – See your color combinations instantly as you make changes</li>
<li>Color Shade Exploration – View multiple lighter and darker variations of your chosen colors</li>
<li>One-Click Application – Apply any shade variation with a simple click</li>
<li>Multiple Input Methods – Enter colors using hex codes or RGB values</li>
<li>Color Picker Integration – Select colors using standard color selection dialogs</li>
<li>Font Size Adjustment – Test readability at different font sizes</li>
<li>Bold Text Option – Toggle between normal and bold text to assess impact</li>
<li>Copy-to-Clipboard – Right-click any color swatch to copy its hex code</li>
<li>Accessible Design – Intuitive layout with clear labeling and controls</li>
<li>Preview Panel – Test your colors with sample text in a realistic preview</li>
<li>Optimized Workflow – Experiment rapidly with different combinations</li>
<li>No Internet Connection Required – Complete privacy with offline operation</li>
</ul>
<b>Perfect For:</b><ul>
<li>Web designers selecting color schemes for sites and applications</li>
<li>Document creators ensuring readability in reports and presentations</li>
<li>UI/UX designers testing color accessibility</li>
<li>Brand managers maintaining color consistency</li>
<li>Digital artists experimenting with color palettes</li>
<li>Educators creating readable teaching materials</li>
<li>Content creators designing visually appealing documents</li>
<li>Anyone who needs to find harmonious text and background color combinations</li>
</ul>
Discover the perfect text and background color combination with NeuLogic<span style={tmStyle}>™</span> Text Color Visualizer - your essential tool for visual communication!<br/><br/>
<b>App Features:</b><ul>
<li>Set text and background colors using hex codes or RGB values</li>
<li>Preview colors in real-time with sample text</li>
<li>Explore multiple shade variations for each color</li>
<li>Adjust font size using a convenient slider</li>
<li>Toggle bold text option for different emphasis</li>
<li>Copy any color's hex code to clipboard</li>
<li>View color information in tooltips</li>
<li>Test readability with realistic text samples</li>
<li>No internet connection required – complete privacy</li>
<li>Simple, intuitive interface</li>
</ul>
<b>System Requirements:</b><ul>
<li>Windows 10 or higher</li>
<li>30 MB of free disk space</li>
<li>128 MB RAM</li>
</ul>
</div>`,
    price: 0,
    stripeLink: ""
  }
];

export default products;
